import * as Sentry from '@sentry/browser'
import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Modal } from 'components'
import { COLUMNS_HISTORY, ProductHistory } from 'features/Ticket'
import { findProductHistoriesByProductId } from 'features/Product'
import ProductHistoryBody from './TicketProductHistoryBody'
import { ISorting } from 'types'
import { IParam } from 'libs/apis'

export type PropsTicketProductHistoryModal = {
  productId: string
  isOpen: boolean
  onClose: () => void
}

export type ParamsProductHistories = {
  isCompleted: boolean
  isActive: boolean
} & IParam

const initHistories: ProductHistory[] = []
const initSearchParams: ParamsProductHistories = {
  _sort: 'code',
  _order: 'DESC',
  _limit: '0',
  isCompleted: true,
  isActive: true,
}

const TicketProductHistoryModal: React.FC<PropsTicketProductHistoryModal> = (
  props,
) => {
  const { t } = useTranslation('ticket')
  const { productId, isOpen, onClose } = props

  const base = 'f-ticket-product-history-modal'
  const [searchParams, setSearchParams] =
    useState<ParamsProductHistories>(initSearchParams)
  const [histories, setHistories] = useState<ProductHistory[]>(initHistories)
  const [, setCountHistory] = useState<number>(0)
  const [isHistoriesLoading, setIsHistoriesLoading] = useState<boolean>(true)
  const [isHistoriesError, setIsHistoriesError] = useState<boolean>(false)

  useEffect(() => {
    setIsHistoriesLoading(true)

    if (productId) {
      fetchHistories()
    }
  }, [productId, searchParams])

  const fetchHistories = async () => {
    try {
      const { data, count } = await findProductHistoriesByProductId(
        productId,
        searchParams,
      )
      const _histories = data as ProductHistory[]

      setHistories(_histories)
      setCountHistory(count || 0)
      setIsHistoriesLoading(false)
    } catch (error) {
      Sentry.captureException(error)

      setIsHistoriesError(true)
    }
  }

  const handleSortChange = (sort: ISorting) => {
    setIsHistoriesLoading(true)
    setSearchParams({
      ...searchParams,
      _sort: sort.column,
      _order: sort.order,
      _limit: '0',
    })
  }

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div className={`${base}__content`}>
        <div className={`${base}__modal-header`}>
          <span
            className={`${base}__modal-header--title`}
            data-testid='product-history-modal-title'
          >
            {t('maintenanceHistory')}
          </span>
        </div>

        <ProductHistoryBody
          columns={COLUMNS_HISTORY}
          isError={isHistoriesError}
          isLoading={isHistoriesLoading}
          histories={histories}
          sorting={{
            column: searchParams._sort as string,
            order: searchParams._order || 'DESC',
          }}
          handleSortChange={handleSortChange}
        />
      </div>
    </Modal>
  )
}

export default TicketProductHistoryModal
